import React from 'react';
import { Search } from './components/Search';
import { CreateBtn } from './components/CreateBtn';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import { ResetBtn } from './components/ResetBtn';
import { SortBy } from './components/SortBy/SortBy';
import { CountOfItem } from './components/CountOfItem';
import { WithURLFilters } from './components/WithURLFilters';
import style from './ModifierGroupControlPanel.module.scss';

export const ModifierGroupControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.selectWrapper}>
					<CustomerSelect />
					<RestaurantSelect />
				</div>
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};
